module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"helpTranslate":"Nápověda k překladu Central"},"de":{"helpTranslate":"Hilf Central zu übersetzen"},"es":{"helpTranslate":"Ayuda a traducir Central"},"fr":{"helpTranslate":"Aider à traduire Central"},"id":{"helpTranslate":"Bantu terjemahan pusat"},"it":{"helpTranslate":"Aiuta a tradurre Central"},"ja":{"helpTranslate":"Centralの翻訳に貢献する"}}')
  delete Component.options._Ctor
}
